import { createContext, useContext } from "react";
import { ProgressContextType } from "./types";

const ProgressContext = createContext<ProgressContextType>({} as any);

const useProgressContext = () => useContext(ProgressContext);

export { ProgressContext, useProgressContext };
